<!-- 通过手机号和短信验证码登录 -->
<template>
  <div id="userLoginPan">
    <i
        @click="loginCheck" title="登录"
        class="el-icon-user-solid"
        style="font-size: 30px;position: relative;top:30px;margin-right: 20px;color:#000;cursor: pointer;"
        >
    </i>
    <el-dialog
      v-model="dialogVisible"
      width="30%"
      v-bind="$attrs"
      @open="onOpen"
      @close="onClose"
      title="验证码登录"
    >
      <el-row :gutter="15">
        <el-form
          ref="elForm"
          :model="formData"
          :rules="rules"
          size="medium"
          label-width="100px"
        >
          <el-col :span="24">
            <el-row>
              <el-col :span="22">
                <el-form-item label="手机号" prop="userNickName">
                  <el-input
                    v-model="formData.userNickName"
                    placeholder="请输入手机号"
                    :maxlength="11"
                    show-word-limit
                    clearable
                    prefix-icon="el-icon-phone"
                    :style="{ width: '100%' }"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="14">
                <el-form-item label="手机验证码" prop="msgcode">
                  <el-input
                    v-model="formData.msgcode"
                    placeholder="请输入手机验证码"
                    :maxlength="4"
                    show-word-limit
                    clearable
                    prefix-icon="el-icon-info"
                    :style="{ width: '100%' }"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10" style="text-align:left;">
                <el-form-item label-width="0" style="margin-left: 10px;">
                  <el-button
                    @click="send"
                    size="small"
                    style=""
                    type="success"
                    :disabled="(disabled = !show)"
                  >
                    <span v-show="show">点我获取手机验证码</span>
                    <span v-show="!show" class="count">{{ count }} s</span>
                  </el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-form>
      </el-row>
      <template #footer>
        <div style="padding-right: 50px;">
          <span @click="changeLoginType" style="color: #409eff; cursor: pointer;">
            密码登录
          </span>&nbsp;&nbsp;
          <el-button @click="onClose">取消</el-button>
          <el-button type="primary" @click="userLogin" >登&nbsp;&nbsp;&nbsp;&nbsp;录</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script>
export default {
  emits: ['changeLoginWayEvent'],
  data () {
    return {
      dialogVisible: false,
      formData: {
        userNickName: '',
        msgcode: ''
      },
      timer: null /* 计时器,注意需要进行销毁  */,
      show: true /* 初始启用按钮 */,
      count: '' /*  初始化次数 */,
      rules: {
        userNickName: [
          {
            required: true,
            message: '请输入手机号',
            trigger: 'blur'
          },
          {
            pattern: /^1(3|4|5|7|8|9)\d{9}$/,
            message: '手机号格式错误',
            trigger: 'blur'
          }
        ],
        msgcode: [
          {
            required: true,
            message: '请输入手机验证码',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    changeLoginType () {
      this.$emit('changeLoginWayEvent')
      this.onClose()
    },
    loginCheck () {
      if (this.$store.state.globalObj.nowUserLoginState) {
        this.$router.push('/imgList/barrel').catch(() => {})
      } else {
        this.dialogVisible = true
      }
    },
    onOpen () {},
    onClose () {
      this.dialogVisible = false
      this.$refs.elForm.resetFields()
    },
    isvaliduserPhoneNum (str) {
      const reg = /^1[3|4|5|7|8][0-9]\d{8}$/
      return reg.test(str)
    },
    send () {
      const tag = this.isvaliduserPhoneNum(this.formData.userNickName)
      if (!tag) {
        this.$message({
          message: '请输入手机号',
          type: 'warning'
        })
        return
      }
      this.doSenduserPhoneNumCode() /* 发送验证码 */
      if (!this.timer) {
        this.count = 60
        this.show = false
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= 60) {
            this.count--
          } else {
            this.show = true
            clearInterval(this.timer) // 清除定时器
            this.timer = null
          }
        }, 1000)
      }
    },
    doSenduserPhoneNumCode () {
      const tel = this.formData.userNickName
      const api = '/md/front/user/sendTelCode'
      const params = {
        telNum: tel
      }
      this.axios.post(api, this.$stringify(params)).then(res => {
        if (res.status === 200) {
          this.$alert('发送成功', '提示')
        }
      })
    },
    userLogin () {
      this.$refs.elForm.validate(valid => {
        if (!valid) return
        this.doLogin()
      })
    },
    doLogin () {
      const api = '/md/front/user/loginByTel'
      const params = {
        telNum: this.formData.userNickName,
        msgcode: this.formData.msgcode
      }
      this.axios.post(api, this.$stringify(params)).then(res => {
        if (res.status === 200) {
          this.$store.commit('setGlobalObjOfNowUserLoginState', true)
          // this.$router.push('/imgList/barrel').catch(() => {}) // 让vue router帮我们进入目标组件
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
.bnsize {
  font-size: 20px;
  position: relative;

}
#userLoginPan :deep(.el-input__inner) {
  color: #000;
}

::v-deep .el-dialog__header {
    text-align: center;
}
</style>
